export const BANNER_BACK_BUTTON_INDENT = {
  SIZE_20: '--banner-back-button-indent-size-20',
} as const
export type BANNER_BACK_BUTTON_INDENT =
  (typeof BANNER_BACK_BUTTON_INDENT)[keyof typeof BANNER_BACK_BUTTON_INDENT]
